import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { magpCMSApi } from "~/Services";
interface GalleryList {
  id: any;
  title: string;
  field_gallery_title_ms: string;
  field_gallery_title_zh: string;
  field_src_url: string;
  field_src_type: string;
  field_gallery_published: boolean;
  field_gallery_created_at: string;
  field_gallery_updated_at: string;
}

const useGalleryList = (
  id?: any,
  options?: UseQueryOptions<GalleryList[], DefaultError, GalleryList[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<GalleryList[], DefaultError> => {
  return useQuery<GalleryList[], DefaultError, GalleryList[], QueryKey>(
    {
      queryKey: ["gallery", id],
      enabled: false,
      queryFn: async (): Promise<GalleryList[]> => {
        const response = await magpCMSApi.get<GalleryList[]>(`/api/get-gallery-page-id/${id}`);

        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useGalleryList };
